import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site-data';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            按主题浏览
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            我们已将黄本子的相关知识按主题精心分类，方便您快速找到所需内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 hover:bg-background-100/80 transition-all duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 篇文章
                </span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}